import { render, staticRenderFns } from "./ReportTabDetails.vue?vue&type=template&id=9551f832&scoped=true&"
import script from "./ReportTabDetails.vue?vue&type=script&lang=ts&"
export * from "./ReportTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9551f832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
